// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ZeqX","title":"Info_title__1MU48","links":"Info_links__1X4cy","link":"Info_link__1Xg2L","logo":"Info_logo__2iDgE"};